exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-split[data-v-5d25427b]{height:calc(100% - 16px);border:1px solid #dcdee2}.demo-split-pane[data-v-5d25427b]{padding:10px;height:100%}.m-tree[data-v-5d25427b]{height:calc(100% - 30px);overflow-y:auto;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5d25427b","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdEducationPlan/parts/pdPatientEducationPlan/pdPatientEducationPlanAdd.vue
// module id = iSY1
// module chunks = 0